<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-29 14:03:58
 * @FilePath: /wemeet-admin-new/src/views/userCenter/userManage/components/userDetail.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
  >
    <div class="containerForm">
      <el-descriptions border class="margin-top" title="用户基础信息">
        <el-descriptions-item label="用户名">
          {{ detail.name }}
        </el-descriptions-item>

        <el-descriptions-item label="手机号">
          {{ detail.phone }}
        </el-descriptions-item>

        <el-descriptions-item label="email">
          <!-- {{ userBaseInfo.email }} -->
          {{ detail.email ? detail.email : '/' }}
        </el-descriptions-item>

        <el-descriptions-item label="公司">
          {{ detail.company ? detail.company : '/' }}
        </el-descriptions-item>

        <el-descriptions-item label="职位">
          {{ detail.position ? detail.position : '/' }}
        </el-descriptions-item>

        <!-- <el-descriptions-item label="uid">
          {{ detail.uid }}
        </el-descriptions-item> -->

        <el-descriptions-item label="用户头像">
          <el-image
            :src="
              detail.avatar
                ? detail.avatar
                : 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/new-default-avatar.png'
            "
            style="width: 50px; height: 50px"
          />
        </el-descriptions-item>

        <el-descriptions-item label="地区">
          {{ detail.country ? detail.country + (detail.address ? '-' + detail.address : '') : '/' }}
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions v-if="detail.realNameType != 'NO_REAL'" border class="margin-top" title="用户实名信息">
        <el-descriptions-item label="真实姓名">
          {{ detail.name }}
        </el-descriptions-item>

        <el-descriptions-item label="实名状态">已实名</el-descriptions-item>

        <el-descriptions-item label="实名类型">
          {{ cardType[detail.idType] }}
        </el-descriptions-item>

        <el-descriptions-item label="证件号码/证件内容">
          {{ detail.idNo }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- <el-descriptions class="margin-top hideLabel" title="用户标签信息">
        <el-descriptions-item>
          <el-transfer v-model="leftValue" style="text-align: left; display: inline-block" :left-default-checked="[]" :right-default-checked="[]" :titles="['从现有标签中选择', '已选标签']" :button-texts="['取消', '保存']" :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}',
      }" :data="data">
          </el-transfer>
        </el-descriptions-item>
      </el-descriptions> -->

      <el-descriptions class="margin-top hideLabel" title="入池时间">
        <el-descriptions-item label="">
          {{ detail.createTime }}
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class="margin-top hideLabel" title="用户备注">
        <el-descriptions-item label="">
          <el-input
            v-model="detail.remark"
            :autosize="{ minRows: 5, maxRows: 10 }"
            maxlength="100"
            placeholder="请输入备注"
            style="width: 80%"
            type="textarea"
            @blur="upDateRemark"
          />
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class="margin-top hideLabel" title="参加过的项目">
        <el-descriptions-item label="">
          <el-table :data="attendList" style="width: 100%">
            <el-table-column align="center" label="项目名称" show-overflow-tooltip>
              <template #default="{ row }">
                {{ row.meetingName ? row.meetingName : '/' }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="项目类型" show-overflow-tooltip>
              <template #default="{ row }">
                {{ row.meetingType ? (row.meetingType == 'EXHIBITION' ? '展览' : '会议') : '/' }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="获得身份" show-overflow-tooltip>
              <template #default="{ row }">
                {{ row.userIdentity ? handleIdentity(row.userIdentity) : '/' }}
              </template>
            </el-table-column>
            <el-table-column label="获得时间" prop="createTime" />
          </el-table>

          <el-pagination
            background
            :current-page="queryForm.pageNumber"
            :layout="layout"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import {
    enterPriseUserQueryUserDetail,
    enterPriseUserQueryUserDetailAttend,
    enterPriseUserUpdateRemark,
  } from '@/api/enterPriseApi'
  import { getIdentity } from '@/api/channel'
  export default defineComponent({
    name: 'GenerateWx',
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '60%',
        title: '链接地址',
        loading: null,
        senceKey: '',
        queryForm: {
          pageNum: 1,
          pageSize: 10,
        },
        total: 0,
        noQrCodeBox: false,
        website: '',
        h5Url: '',
        userBaseInfo: {},
        leftValue: '',
        detail: {},
        layout: 'total, sizes, prev, pager, next, jumper',
        identityList: [],
        total: 0,
        cardType: {
          CERTIFICATES_TYPE_1: '身份证',
          CERTIFICATES_TYPE_2: '回乡证',
          CERTIFICATES_TYPE_3: '台胞证',
          CERTIFICATES_TYPE_4: '外国人永久居住证',
          CERTIFICATES_TYPE_5: '外国护照',
          CERTIFICATES_TYPE_6: '军人证',
          CERTIFICATES_TYPE_7: '外国人手机验证码认证',
          CERTIFICATES_TYPE_8: '港澳台居民居住证',
          CERTIFICATES_TYPE_99: '其他',
        },
        attendList: [],
      })

      const handleIdentity = (key) => {
        return state.identityList.filter((v) => v.identityType == key)[0].name
      }
      // 打开
      const handleOpen = async (row = {}, qrCodeParams, noQrcode, h5Url) => {
        state.row = row

        const { data } = await enterPriseUserQueryUserDetail({ uid: row.uid })

        state.detail = data

        let resp = await getIdentity()
        console.log(resp)
        state.identityList = resp.data

        state.queryForm.uid = row.uid
        await fetchAttendData()
        state.dialogFormVisible = true
      }

      const fetchAttendData = async () => {
        const { data: attendList } = await enterPriseUserQueryUserDetailAttend(state.queryForm)
        state.attendList = attendList.list
        state.total = attendList.total
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchAttendData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchAttendData()
      }

      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const upDateRemark = async () => {
        const { data } = await enterPriseUserUpdateRemark({
          uid: state.row.uid,
          remark: state.detail.remark,
        })
        proxy.$message.success('修改成功')
        emit('fetch-data')
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleIdentity,
        handleSizeChange,
        handleCurrentChange,
        upDateRemark,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
